function maxLengthCheck(object) {
  if (object.value > 10) object.value = 10;
  if (object.value < 1) object.value = 1;
}

$(() => {
  $('#datepicker-event').datepicker({
    format: 'mm-dd-yyyy'
  });

  $('form[name="category"]').submit(function () {
    if ($(this).find('input[name="event-title"]').length > 0) {
      $(this).find('input[name="event-title"]').val($('#name').val());
      $(this).find('input[name="event-date"]').val($('#date').val());
      $(this).find('input[name="event-services"]').val($('#services').val());
    }
    if ($(this).find('input[name="event-services"]').length > 0) {
      $(this).find('input[name="event-services"]').val($('#services').val());
    }
  });
});
